import React from "react";
import "./LifeAtImpact.css";
import { images } from "../../assets";

function LifeAtImpact() {
  return (
    <div className="lifeAtImpact">
      <div className="lifeAtImpactBox">
        <div className="impactContent">
          <div className="impactTitle">Life at Impact</div>
          <div className="impactMessage">
            Cannot be described in sentences. Let us try using just words and
            pictures instead.
          </div>
          <div className="impactHastag">
            #Fun #Free #Accountable #OKRs #Sprints #Scrums #Github #Jira #Slack
            #Gmail #Meetings #Partners #Sales #Operations #Data #Analytics #GA
            #Firebase #Clevertap #OneSignal #Freshchat #Figma #Features #Flows
            #Funnels #Brands #Marketing #Goals #Community #Health #Happiness.
          </div>
        </div>
        <div className="lifeAtImpactGallery">
          <div className="galleryRow1">
            <img className="iGallery1" src={images.iGallery1} alt="iGallery1" />
            <img className="iGallery2" src={images.iGallery2} alt="iGallery2" />
            <img className="iGallery3" src={images.iGallery3} alt="iGallery3"/>
            <img className="iGallery4" src={images.iGallery4} alt="iGallery4"/>
          </div>
          <div className="galleryRow2">
            <img className="iGallery5" src={images.iGallery5} alt="iGallery5"/>
            <img className="iGallery6" src={images.iGallery6} alt="iGallery6"/>
            <img className="iGallery7" src={images.iGallery7} alt="iGallery7"/>
            <img className="iGallery8" src={images.iGallery8} alt="iGallery8"/>
          </div>
        </div>
        <div className="impactGalleryMobile">
            <img id="galleryPic1" className="galleryPic"src={images.galleryPic1} alt="galleryPic1" />
            <img id="galleryPic2" className="galleryPic"src={images.galleryPic2} alt="galleryPic2" />
            <img id="galleryPic3" className="galleryPic"src={images.galleryPic3} alt="galleryPic3"/>
            <img id="galleryPic4" className="galleryPic"src={images.galleryPic4} alt="galleryPic4"/>
        </div>
      </div>
    </div>
  );
}

export default LifeAtImpact;
